module.exports = __webpack_public_path__ + "img/bg-rectangle-1.78fbbd6d.svg";